import { SvgNames } from '@sunrun/experience-ui-components';
import { WORKDAY_EVENT_TYPE, type WorkdayEventType } from 'constants/workday';

type WorkHoursStatusPillType = 'success' | 'error' | 'warning';

type WorkHoursStatusPillConfig = {
  text: string;
  type: WorkHoursStatusPillType;
  icon: SvgNames;
};

const isNonProductiveTimeEntry = (descriptor?: string): boolean =>
  Boolean(descriptor?.toLowerCase().includes('non-productive'));

const getWorkHoursStatusPillConfig = (
  eventType: WorkdayEventType | null,
  timeEntryCodeDescriptor?: string,
): WorkHoursStatusPillConfig | null => {
  if (eventType === WORKDAY_EVENT_TYPE.CLOCK_OUT) {
    return {
      text: 'Checked-out',
      type: 'error',
      icon: SvgNames.ClockCountdown,
    };
  }

  if (eventType === WORKDAY_EVENT_TYPE.MEAL_BREAK) {
    return {
      text: 'Meal Break',
      type: 'warning',
      icon: SvgNames.Coffee,
    };
  }

  if (eventType === WORKDAY_EVENT_TYPE.CLOCK_IN) {
    return {
      text: isNonProductiveTimeEntry(timeEntryCodeDescriptor)
        ? 'Checked-in non-productive hours'
        : 'Checked-in productive hours',
      type: 'success',
      icon: SvgNames.ClockCountdown,
    };
  }

  return null;
};

export { getWorkHoursStatusPillConfig };
export type { WorkHoursStatusPillConfig, WorkHoursStatusPillType };
